export const breakpoints = {
  0: {
    slidesPerView: 1.9,
    spaceBetween: 8,
  },
  400: {
    slidesPerView: 2.1,
    spaceBetween: 8,
  },
  500: {
    slidesPerView: 2.5,
    spaceBetween: 8,
  },
  768: {
    slidesPerView: 5,
    spaceBetween: 24,
  },
};
